import type { VariantProps } from 'tailwind-variants'
import { tv } from 'tailwind-variants'

export const badge = tv({
  slots: {
    container: 'absolute z-10 flex h-3 w-3 items-center justify-center rounded-full bg-ui-light',
    outerCircle: 'flex items-center justify-center rounded-full',
    innerCircle: 'rounded-full',
  },
  variants: {
    position: {
      topLeft: {
        container: '-left-1.5 -top-1.5',
      },
      topRight: {
        container: '-right-1.5 -top-1.5',
      },
      bottomLeft: {
        container: '-bottom-1.5 -left-1.5',
      },
      bottomRight: {
        container: '-bottom-1.5 -right-1.5',
      },
    },
    variant: {
      online: {
        outerCircle: 'h-2 w-2 bg-ui-green',
        innerCircle: 'bg-ui-green',
      },
      offline: {
        outerCircle: 'h-2 w-2 bg-ui-grey',
        innerCircle: 'h-1.5 w-1.5 bg-ui-light',
      },
      message: {
        outerCircle: 'h-2.5 w-2.5 bg-ui-red',
        innerCircle: 'h-1 w-1 bg-ui-light',
      },
    },
  },
  defaultVariants: {
    position: 'topLeft',
    variant: 'message',
  },
})

export type BadgePosition = VariantProps<typeof badge>['position']
